module.exports = __webpack_public_path__ + "static/img/indexBgBig.574aa80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexBgBig.png
// module id = iNFA
// module chunks = 18